export default "__VITE_ASSET__e3344925__"